export const isWithinThreshold = (
  number: number,
  lower: number,
  upper: number
) => number >= lower && number < upper;
